<template>
    <div class="text-center">
        <v-pagination
            v-model="localCurrentPage"
            :length="meta.last_page"
            :total-visible="7"
            @input="onPageChange"
            color="blue darken-1"
        ></v-pagination>
    </div>
</template>

<script>
export default {
  name: 'PaginationComponent',
  props: {
    meta: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localCurrentPage: 1
    };
  },
  watch: {
    'meta.current_page'(newVal) {
      this.localCurrentPage = newVal;
    }
  },
  created() {
    this.localCurrentPage = this.meta.current_page;
  },
  methods: {
    onPageChange(page) {
        this.$emit('page-changed', page);
    }
  }
};
</script>